<script>
  import formatarData from '~js/formatar-data';
  import 'vue-strap/dist/vue-strap-lang';
  import { datepicker } from 'vue-strap';
  import tipoCertidaoServico from '~modulos/certidao/servico';
  import FileInput from '~componentes/InputFile.vue'
  
  export default {
    components: { datepicker, FileInput },
    props: {
      certidoes: {
        type: Array,
        required: true,
      },
      arquivosCertidoes: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        certidao: this.camposCertidoes(),
        tiposCerdidoes: [],
        tiposCerdidoesLiberadas: [],
        observacaoCertidao: 'Nenhuma certidão selecionada.',
        arquivo: [],
        arquivosDeletados: [],
        verificarArquivo: "required",
        mensagem: '',
      }
    },
    methods: {
      validar() {
        this.$validator
          .validateAll()
          .then(valido => {
            if (valido) {
              const dataInicial = new Date(this.certidao.dataValidade.split('/').reverse().join('-'));
              const dataFinal = new Date(this.certidao.dataValidadeFim.split('/').reverse().join('-'));
            
              if (dataInicial > dataFinal) {
                this.$swal('', 'A data de validade final da certidão deve ser maior que a data inicial.', 'error');
              } else {
                this.adicionar();
              }
            }
          })
      },
      validarDadosNaoEnviados(){
        if(this.certidao.idCertidao != '')
          return false;
        if(this.certidao.numeroCertidao != '')
          return false;
        if(this.certidao.dataValidade != '')
          return false
        if(this.certidao.dataValidadeFim != '')
          return false;
        if(this.certidao.observacaoCertidao != '')
          return false;
        if(this.arquivo != null && this.arquivo.length != 0)
          return false 

        return true;
      },
      nomeTipoCertidao(id) {
        return this.tiposCerdidoes.find(tipoCertidao => {
          return tipoCertidao.idCertidao === id;
        }).nomeCertidao;
      },
      carregarTiposCerdidoes() {
        return tipoCertidaoServico.
          lista()
          .then(tiposCertidoes => {
            this.tiposCerdidoes = tiposCertidoes;
            this.tiposCerdidoesLiberadas = tiposCertidoes
              .filter(certidao => certidao.utilizarModuloCompras === 1)
              .sort((a, b) => a.nomeCertidao.localeCompare(b.nomeCertidao));
          });         
      },
      definirObservacaoCertidao() {
        let certidaoSelecionada = '';
        if (this.certidao && this.certidao.idCertidao) {
          certidaoSelecionada = this.tiposCerdidoes.find(tipoCertidao => {
            return tipoCertidao.idCertidao === this.certidao.idCertidao;
          });
        }
        this.observacaoCertidao = 'Esta certidão não possui descrição.';

        if (certidaoSelecionada.observacaoCertidao) {
          this.observacaoCertidao = certidaoSelecionada.observacaoCertidao.replace(/\r\n/g, '<br>');
        } else if (this.certidao.idCertidao === 0 || this.certidao.idCertidao === '') {
          this.observacaoCertidao = 'Nenhuma certidão selecionada.';
        }

        return;
      },
      modalObservacaoCertidao() {
        this.$swal({
          title: 'Descrição da Certidão',
          html: '<br><br>' + this.observacaoCertidao.replace(/\r\n/g, '<br>') + '<br><br>',
          type: 'info',
          showCancelButton: false,
          confirmButtonText: 'Entendido!',
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      },
      deletar(indice) {
        this.arquivosDeletados.push(this.certidoes[indice].nomeArquivo)
        this.certidoes.splice(indice, 1);             
      },
      editar(indice) {
        const certidao = this.certidoes[indice];
        this.certidoes.splice(indice, 1);
        this.certidao.id = certidao.id;
        this.certidao.idCertidao = certidao.idCertidao;
        this.certidao.numeroCertidao = certidao.numeroCertidao;
        this.certidao.dataValidade = formatarData.paraData(certidao.dataValidade);
        this.certidao.dataValidadeFim = formatarData.paraData(certidao.dataValidadeFim);
        this.certidao.tipoArmazenamento = certidao.tipoArmazenamento;
        this.certidao.observacaoCertidao = certidao.observacaoCertidao;

        if (certidao.id > 0) {
          this.$refs.fileInput.arquivo = [];
          this.$refs.fileInput.arquivo.name = certidao.nomeArquivo;
        }

        //this.verificarArquivo = "";
      },
      download(certidao) {
        this.$emit('downloadCertidao', certidao.id, certidao.nomeArquivo);
      },
      async adicionar() {
        const copiaCertidao = Object.assign(this.certidao);

        if (this.arquivo && 'name' in this.arquivo) {

          copiaCertidao.nomeArquivo = this.arquivo.name;
          this.arquivosCertidoes.push(this.arquivo);
        } else {

          copiaCertidao.nomeArquivo = this.$refs.fileInput.arquivo
            ? this.$refs.fileInput.arquivo.name
            : 'Sem arquivo';
        }

        if (copiaCertidao.nomeArquivo.startsWith('teste.')) {
          this.mensagem = 'Arquvo não pode ter o nome de "teste"!';
          this.$refs.fileInput.removerArquivo();
        } else {
          this.mensagem = '';

          copiaCertidao.dataValidade = await formatarData.paraNumero(copiaCertidao.dataValidade);
          copiaCertidao.dataValidadeFim = await formatarData.paraNumero(copiaCertidao.dataValidadeFim);

          this.certidoes.push(copiaCertidao);
          this.certidao = this.camposCertidoes();
          //this.verificarArquivo = "required";
          this.$refs.fileInput.removerArquivo();
          this.$validator.reset();
        }
      },
      camposCertidoes() {
        return {
          id: 0,
          idCertidao: '',
          numeroCertidao: '',
          observacaoCertidao: '',
          dataValidade: '',
          dataValidadeFim: '',       
          tipoArmazenamento: 0,
          nomeArquivo: '',
        }
      }
    },
    mounted() {
      this.carregarTiposCerdidoes();
    }
  }
</script>

<style>
  .icon-container {
    cursor: pointer;
    display: inline-block;
  }
  .disabledObservacaoCertidao {
    background-color: #f5f5f5;
    border: 1px solid #ccc;
    padding-bottom: 6px;
    padding-top: 6px;
    padding-left: 12px;
    padding-right: 12px;
    color: #999;
    cursor: not-allowed;
  }
</style>

<template>
  <div>

    <div class="table-responsive">
      <table class="table table-hover table-pointer">
        <thead>
          <tr>
            <th>Tipo de Certidão</th>
            <th>Número da Certidão</th>
            <th>Data de validade inicial</th>
            <th>Data de validade final</th>
            <th>Observação</th>
            <th>Arquivo</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(certidao, indice) in certidoes">
            <td>{{ nomeTipoCertidao(certidao.idCertidao) }}</td>
            <td>{{ certidao.numeroCertidao }}</td>
            <td>{{ certidao.dataValidade | formatarNumeroEmData('---') }}</td>
            <td>{{ certidao.dataValidadeFim | formatarNumeroEmData('---') }}</td>
            <td>{{ certidao.observacaoCertidao }}</td>
            <td>{{ certidao.nomeArquivo }}</td>
            <td class="action">
              <button type="button"
                      class="btn btn-warning btn-xs"
                      @click="editar(indice)">
                <i class="fa fa-edit"></i>
              </button>
            </td>
            <td v-if="certidao.nomeArquivo !== 'Sem arquivo' && certidao.id !== 0" class="action">
              <button type="button"
                      class="btn btn-xs btn-success"
                      @click="download(certidao)">
                <i class="fa fa-download"></i>
              </button>
            </td>
            <td class="action">
              <button type="button"
                      class="btn btn-danger btn-xs"
                      @click="deletar(indice)">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
          <tr v-if="certidoes.length === 0">
            <td colspan="6" class="text-center">Nenhum registro encontrado.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="form-group required" :class="{'has-error': errors.has('idCertidao')}">
          <!--<label class="control-label" for="id-certidao">
          Tipo de certidão
          <span class="icon-container" @click="modalObservacaoCertidao">
            <i class="fa fa-question-circle" aria-hidden="true"></i>
          </span>
        </label>-->
          <label class="control-label" for="id-certidao">Tipo de certidão</label>

          <select class="form-control"
                  id="id-certidao"
                  v-model="certidao.idCertidao"
                  data-vv-name="idCertidao"
                  data-vv-as="idCertidao"
                  v-validate="'required'"
                  @change="definirObservacaoCertidao">
            <option value="">Selecione...</option>
            <option :value="tipoCertidao.idCertidao" v-for="tipoCertidao in tiposCerdidoesLiberadas">{{ tipoCertidao.nomeCertidao }}</option>
          </select>

          <p class="text-danger" v-show="errors.has('idCertidao')">{{ errors.first('idCertidao') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="form-group">
          <label class="control-label" for="id-descricao-certidao">Descrição da certidão</label>

          <div class="disabledObservacaoCertidao" v-html="observacaoCertidao"></div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-4">
        <div class="form-group required" :class="{'has-error': errors.has('numeroCertidao')}">
          <label class="control-label" for="numero-certidao">Número da certidão</label>

          <input type="text"
                 class="form-control"
                 id="numero-certidao"
                 maxlength="30"
                 v-model="certidao.numeroCertidao"
                 data-vv-name="numeroCertidao"
                 data-vv-as="numeroCertidao"
                 v-validate="'required'">

          <p class="text-danger" v-show="errors.has('numeroCertidao')">{{ errors.first('numeroCertidao') }}</p>
        </div>
      </div>

      <div class="col-lg-4">
        <div class="form-group required" :class="{'has-error': errors.has('dataValidade')}">
          <label class="control-label" for="data-validade">Data de validade inicial</label>

          <datepicker v-model="certidao.dataValidade"
                      format="dd/MM/yyyy"
                      placeholder="  /  /     "
                      lang="pt-BR"
                      data-vv-name="dataValidade"
                      data-vv-as="data de validade inicial"
                      v-validate="'required|date_format:DD/MM/YYYY'">
          </datepicker>

          <p class="text-danger" v-show="errors.has('dataValidade')">{{ errors.first('dataValidade') }}</p>
        </div>
      </div>

      <div class="col-lg-4">
        <div class="form-group required" :class="{'has-error': errors.has('dataValidadeFim')}">
          <label class="control-label" for="data-validade-fim">Data de validade final</label>

          <datepicker v-model="certidao.dataValidadeFim"
                      format="dd/MM/yyyy"
                      placeholder="  /  /     "
                      lang="pt-BR"
                      data-vv-name="dataValidadeFim"
                      data-vv-as="data de validade final"
                      v-validate="'required|date_format:DD/MM/YYYY'">
          </datepicker>

          <p class="text-danger" v-show="errors.has('dataValidadeFim')">{{ errors.first('dataValidadeFim') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="form-group" :class="{'has-error': errors.has('observacaoCertidao')}">
          <label class="control-label" for="observacao-certidao">Observação</label>

          <textarea class="form-control"
                    id="observacao-certidao"
                    v-model="certidao.observacaoCertidao"
                    data-vv-name="observacaoCertidao"
                    data-vv-as="observacao certidao"
                    v-validate="''"
                    maxlength="300">
          </textarea>

          <p class="text-danger" v-show="errors.has('observacaoCertidao')">{{ errors.first('observacaoCertidao') }}</p>
        </div>
      </div>
    </div>


    <div class="row">
      <div class="col-lg-12">
        <!--<div class="form-group required" :class="{'has-error': errors.has('arquivo')}">-->
        <!--<label class="control-label" for="id-arquivo-certidao">Arquivo Certidão</label>-->
        <div class="form-group">
          <label class="control-label" for="id-arquivo-certidao">Arquivo Certidão</label>

          <file-input data-vv-name="arquivo"
                      id="id-arquivo-certidao"
                      data-vv-as="arquivo"
                      v-model="arquivo"
                      ref="fileInput">
            <!-- v-validate="verificarArquivo"-->
          </file-input>

          <p class="text-danger" v-if="mensagem.length > 0">{{ mensagem }}</p>
          <!--<p class="text-danger" v-show="errors.has('arquivo')">{{ errors.first('arquivo') }}</p>-->
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="form-group">
          <button type="button"
                  class="btn btn-success"
                  @click="validar">
            ">
            <i class="fa fa-plus"></i> Adicionar certidão
          </button>
        </div>
      </div>
    </div>

  </div>
  </template>



// WEBPACK FOOTER //
// FrontEnd/modulos/web-fornecedor/componentes/compartilhado/FormCertidoes.vue